$(() => {
  $(".datatable").DataTable(
    {
      "bFilter": false,
      "paging": false,
      "order": [[ 0, "desc" ]]
    }
  )
})
